var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVodalendCompareLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17C1 8.16344 8.16344 1 17 1H35C43.8366 1 51 8.16344 51 17V35C51 43.8366 43.8366 51 35 51H17C8.16344 51 1 43.8366 1 35V17Z",
    fill: "#08081B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0613 41.7417C34.7887 41.7417 41.8637 34.6667 41.8637 25.9392C41.8637 17.2117 34.7887 10.1367 26.0613 10.1367C17.3338 10.1367 10.2588 17.2117 10.2588 25.9392C10.2588 34.6667 17.3338 41.7417 26.0613 41.7417Z",
    fill: "#E60000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1841 34.7439C21.8429 34.7551 17.3231 31.05 17.3008 25.1017C17.2897 21.1734 19.4212 17.3902 22.1331 15.1359C24.778 12.9486 28.405 11.5424 31.6971 11.5312C32.1212 11.5312 32.5676 11.5647 32.8355 11.654C29.9562 12.2566 27.6684 14.9239 27.6796 17.9594C27.6796 18.0598 27.6907 18.1714 27.7019 18.2161C32.5007 19.3878 34.688 22.3006 34.6992 26.3182C34.7215 30.3246 31.5409 34.7328 26.1841 34.7439Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H35V0H17V2ZM50 17V35H52V17H50ZM35 50H17V52H35V50ZM2 35V17H0V35H2ZM17 50C8.71573 50 2 43.2843 2 35H0C0 44.3888 7.61116 52 17 52V50ZM50 35C50 43.2843 43.2843 50 35 50V52C44.3888 52 52 44.3888 52 35H50ZM35 2C43.2843 2 50 8.71573 50 17H52C52 7.61116 44.3888 0 35 0V2ZM17 0C7.61116 0 0 7.61116 0 17H2C2 8.71573 8.71573 2 17 2V0Z",
    fill: "#8A8D9C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVodalendCompareLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vodalend-compare-logo.3cb5e2f67113578f607173a019ef8495.svg";